import { ComponentSettings, empty } from "../settings/settings";

export const settings = {
  permission: {
    manage: false,
    editOwn: false,
    addExpiryDate: false,
  },
  list: {
    columns: empty,
    boxes: empty,
    main: empty,
  },
  url: {},
  text: {
    resetPassword: {
      de: "Kennwort zurücksetzen",
      en: "Reset Password",
      nl: "Reset Wachtwoord",
    },
    requestPassword: {
      de: "Passwortänderung anfordern",
      en: "Request password change",
      nl: "Wachtwoord wijziging aanvragen",
    },
    enterEmail: {
      de: "Bitte geben Sie Ihre E-Mail-Adresse ein. Wir senden Ihnen einen Link zum Zurücksetzen Ihres Passworts.",
      en: "Please enter your email address. We'll send you a link to reset your password.",
      nl: "Voer uw e-mailadres in. Wij sturen u een link om uw wachtwoord opnieuw in te stellen.",
    },
    mustMatch: {
      de: "*Passwörter müssen übereinstimmen",
      en: "*Passwords must match",
      nl: "*Wachtwoorden moeten overeenkomen",
    },
    sendEmail: {
      de: "E-Mail senden",
      en: "Send Email",
      nl: "Verstuur e-mail",
    },
    forgotPassword: {
      de: "Haben Sie Ihr Passwort vergessen? ",
      en: "Forgot your password?",
      nl: "Wachtwoord vergeten? ",
    },
    password: {
      de: "Kennwort zurücksetzen",
      en: "Reset Password",
      nl: "Reset Wachtwoord",
    },
    insertPassword: {
      de: "Bitte geben Sie Ihr neues Passwort ein.",
      en: "Please kindly set your new password.",
      nl: "Stel alstublieft uw nieuwe wachtwoord in.",
    },
    save: {
      de: "Speichern",
      en: "Save",
      nl: "Opslaan",
    },
    succesUserUpdated: {
      de: "Benutzer erfolgreich aktualisiert",
      en: "User updated successfully",
      nl: "Gebruiker succesvol bijgewerkt",
    },
    emailNotCorrect: {
      de: "Die eingeführte E-Mail ist nicht korrekt",
      en: "The introduced email is not correct",
      nl: "De ingevoerde e-mail is niet correct",
    },
    userNotFound: {
      de: "Benutzer nicht gefunden",
      en: "User not found!",
      nl: "Gebruiker niet gevonden",
    },
    userSettingsNotFound: {
      de: "Benutzereinstellungen nicht gefunden",
      en: "User settings not found",
      nl: "Gebruikersinstellingen niet gevonden",
    },
    messageSent: {
      de: "Eine Nachricht zum Zurücksetzen des Passworts wurde an Ihre E-Mail gesendet.",
      en: "A reset password message was sent to your email.",
      nl: "Een reset wachtwoord bericht werd verzonden naar uw e-mail.",
    },
    linkExpired: {
      de: "Der Link ist abgelaufen!",
      en: "Link has expired!",
      nl: "Link is verlopen!",
    },
    redirect: {
      de: "Weiterleitung zum Login...",
      en: "Redirecting to login...",
      nl: "Doorverwijzen naar inloggen...",
    },
    tokenHasBeenUsed: {
      de: "Die Aktivierungs-URL wurde bereits verwendet, bitte fordern Sie ein neues Passwort an.",
      en: "The activation URL has be already used, please request another change password.",
      nl: "De activatie URL is reeds gebruikt, gelieve een ander paswoord aan te vragen.",
    },
    passLength: {
      de: "Das Passwort muss mindestens",
      en: "Password must contain at least",
      nl: "Het wachtwoord moet minimaal",
    },
    char: {
      de: "Zeichen enthalten.",
      en: "characters.",
      nl: "tekens bevatten.",
    },
    upperCase: {
      de: "Das Passwort muss mindestens 1 Großbuchstaben enthalten.",
      en: "Password must contain at least 1 Uppercase letter",
      nl: "Het wachtwoord moet ten minste 1 hoofdletter bevatten.",
    },
    digit: {
      de: "Das Passwort muss mindestens 1 Ziffer enthalten.",
      en: "Password must contain at least 1 Digit",
      nl: "Wachtwoord moet minimaal 1 cijfer bevatten",
    },
    specialChar: {
      de: "Das Passwort muss mindestens 1 Sonderzeichen enthalten.",
      en: "Password must contain at least 1 Special Character",
      nl: "Het wachtwoord moet ten minste 1 speciaal teken bevatten.",
    },
  },
  field: {},
  additionalInfo: {},
};

export const resetPassword: ComponentSettings<typeof settings> = settings;
